import React from "react";
import { Container } from "react-bootstrap";

/**
 * Catches JavaScript errors anywhere in the child component tree and displays
 * a fallback UI instead of crashing the whole page.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // In production you would send this to an error monitoring service.
    console.error("Uncaught error:", error, info.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <Container
          fluid
          className="d-flex flex-column justify-content-center align-items-center"
          style={{ minHeight: "100vh", color: "white", textAlign: "center" }}
          role="alert"
        >
          <h1 className="purple">Something went wrong.</h1>
          <p style={{ color: "#ccc", marginTop: "1rem" }}>
            Please refresh the page. If the problem persists, contact the site
            owner.
          </p>
          <button
            className="btn btn-primary mt-3"
            onClick={() => window.location.reload()}
          >
            Reload Page
          </button>
        </Container>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
